class TootoHeaderProductMega extends HTMLElement {
  #submenuObserver;

  connectedCallback() {
    const submenu = this.closest('.menu-list__submenu');

    if (!submenu || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.setAttribute('data-open', '');
      return;
    }

    this.classList.add('is-motion-ready');

    const syncOpenState = () => {
      if (submenu.hasAttribute('inert')) {
        this.removeAttribute('data-open');
        return;
      }

      requestAnimationFrame(() => this.setAttribute('data-open', ''));
    };

    this.#submenuObserver = new MutationObserver(syncOpenState);
    this.#submenuObserver.observe(submenu, {
      attributes: true,
      attributeFilter: ['inert'],
    });

    syncOpenState();
  }

  disconnectedCallback() {
    this.#submenuObserver?.disconnect();
  }
}

if (!customElements.get('tooto-header-product-mega')) {
  customElements.define('tooto-header-product-mega', TootoHeaderProductMega);
}
